/*
  !IMPORTANT!: This file will be deleted in the future!
  If you want to use this functionality, please rather turn your *.vue file into a composition API and directly use the `useBranding` composable instead.
  This file is only kept for backwards compatibility for old *.vue files that are still using options API and mixins.

  If you want to change the branding functionality, please do it in this mixin AND the composable!
*/

import { waitFor } from 'src/config/setup/plugins/waitFor/index.js'
import Schools from 'src/api/schools.js'

const APIMixin = {
  data: () => ({
    // keep selected school
    school: null
  }),
  computed: {
    // return school Id
    schoolUuid () {
      return this.$route.params.schoolUuid
    }
  },
  methods: {
    // make API calls with respect to selected school
    fetchSchool: waitFor('management-fetch-school-data', async function () {
      this.school = await Schools.getSchoolExtended(this.schoolUuid)
      await this.$store.dispatch('management/setManagementSchool', { uuid: this.schoolUuid })
    }),
    getCurrentActiveClassbook () {
      if (!this.school?.timetable) return
      return this.school.timetable.schoolyears.find(el => el.id === this.school.timetable.active_schoolyear_id)?.classbook
    },
    getCurrentSchoolYearId () {
      if (!this.school?.timetable) return
      return this.school.timetable.active_schoolyear_id
    }
  },
  watch: {
    schoolUuid: {
      handler: function (newUuid, oldUuid) {
        if (this.school?.uuid === newUuid || newUuid === oldUuid) return
        this.fetchSchool()
      },
      immediate: true
    }
  }
}

export default APIMixin
